import Handlebars from 'handlebars';
      const _template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-test-label-self-serve-resolved class=\"ml-4\">\n  <div class=\"font-normal\">Resolved with self-serve content</div>\n</div>\n";
},"useData":true});
      export default _template;